import styled from 'styled-components';

export const ModalTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
    line-height: 1.4;

    @media screen and (max-width: 769px) {
        font-size: 18px;
    }
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ModalDescription = styled.p`
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    margin: 0;
    text-align: center;
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 8px;
`;
